import { createFileRoute, type SearchSchemaInput } from '@tanstack/react-router';

import {
  redirectListParams,
  redirectListQueryOptions,
  redirectListSearchSchema,
  RedirectsPage,
} from '@/features/redirects';

export const Route = createFileRoute('/_authed/_active/s/$storeId/content/redirects')({
  staticData: { crumb: 'common:nav.redirects', tours: ['content.redirects'] },
  // Typed as the raw input so links into the list (the nav, SEO issues' `?q=`) pass what they have.
  validateSearch: (search: Record<string, unknown> & SearchSchemaInput) =>
    redirectListSearchSchema.parse(search),
  loaderDeps: ({ search }) => search,
  loader: async ({ context, params, deps, cause }) => {
    const prefetch = context.queryClient
      .query({
        ...redirectListQueryOptions(params.storeId, redirectListParams(deps)),
        staleTime: 'static',
      })
      .catch(() => undefined);
    // Filter, sort and page changes on the list must not wait for the fetch, or a second pick in
    // the filter would build on the stale URL. The page's own query shows the previous rows.
    if (cause !== 'stay') await prefetch;
  },
  component: RedirectsPage,
});
